module.exports = __webpack_public_path__ + "img/not_found.74f870d4.svg";